import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { saveNotification } from "../redux/action/user";

const usePoiCategory = () => {
  const [loadingPoiCategories, setLoadingPoiCategories] =
    useState<boolean>(true);
  const [poiCategoryGroups, setPoiCategoryGroups] = useState<
    Model.PoiCategoryGroup[]
  >([]);

  const dispatch = useDispatch();

  const fetchPoiCategories = useCallback(() => {
    setLoadingPoiCategories(true);
    return api
      .poiCategories()
      .then((pCategories: Model.PoiCategoryResponse) => {
        setPoiCategoryGroups(pCategories.groups);
      })

      .catch(poiCategoriesError => {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "poiCategories",
            "Fetch Poi categories",
            poiCategoriesError
          )
        );
        throw poiCategoriesError;
      })
      .finally(() => {
        setLoadingPoiCategories(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchPoiCategories();
  }, [fetchPoiCategories]);

  // Re-fetch when the app language changes — poiCategories() is cached per-lang
  // server-side, but this hook otherwise only ever fetches once on mount.
  useEffect(() => {
    const handleLanguageChange = () => {
      fetchPoiCategories();
    };
    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, [fetchPoiCategories]);

  return { poiCategoryGroups, loadingPoiCategories };
};

export default usePoiCategory;
